import PhotoGallery from "./PhotoGallery";
import Antenna from "./projects/Antenna";
import Photoboo from "./projects/Photoboo";
import FishFinder from "./projects/FishFinder";
import Stylegan from "./projects/Stylegan";
import PropagandaGallery from "./projects/PropagandaGallery";
import MeGallery from "./projects/MeGallery";
import TattooGallery from "./projects/TattooGallery";
import PhilGallery from "./projects/PhilGallery";
import ReplacedByAIGallery from "./projects/ReplacedByAIGallery";
import Gallery20191231 from "./projects/Gallery20191231";
import PhotoboothOfFriendship from "./projects/PhotoboothOfFriendship";
import ArtistBuyingOwnNFT from "./projects/ArtistBuyingOwnNFT";
import NftClub from "./projects/NftClub";


export const projectItems = [
  // {
  //   name: 'Butt Crystals',
  //   path: '/projects/buttcrystals',
  //   component: ButtCrystals
  // },
  {
    name: "NFT Club",
    path: "/projects/nftclub",
    component: NftClub,
  },
  {
    name: "Artist buying own NFT of artist buying own NFT",
    path: "/projects/artistbuyingownnft",
    component: ArtistBuyingOwnNFT,
  },
  {
    name: 'Ghostly Photo Booth (aka "Photoboo")',
    path: "/projects/photoboo",
    component: Photoboo,
  },
  {
    name: 'Ghostly Photo Booth (aka "Photoboo") gallery',
    path: "/projects/photoboo/gallery",
    component: PhotoGallery,
  },
  {
    name: "Easy magnetic shipping container antenna mast",
    path: "/projects/antenna",
    component: Antenna,
  },
  {
    name: "Bluetooth 5 long range friend finder",
    path: "/projects/fishfinder",
    component: FishFinder,
  },
  {
    name: "StyleGAN",
    path: "/projects/stylegan",
    component: Stylegan,
  },
  {
    name: "AI Generated Propaganda Gallery",
    path: "/projects/stylegan/propaganda",
    component: PropagandaGallery,
  },
  {
    name: "AI Generated Photos of Myself",
    path: "/projects/stylegan/me",
    component: MeGallery,
  },
  {
    name: "AI Generated Tattoos",
    path: "/projects/stylegan/tattoos",
    component: TattooGallery,
  },
  {
    name: "AI Generated Tattoos",
    path: "/projects/stylegan/phil",
    component: PhilGallery,
  },
  {
    name: "You've been replaced by an AI",
    path: "/projects/replaced",
    component: ReplacedByAIGallery,
  },
  {
    name: "You've been replaced by an AI",
    path: "/a/2019-12-31",
    component: ReplacedByAIGallery,
  },
  {
    name: "",
    path: "/galleries/2019-12-31",
    component: Gallery20191231,
  },
  {
    name: "Photobooth of Friendship",
    path: "/projects/photoboothOfFriendship",
    component: PhotoboothOfFriendship,
  },
];
